<template>
  <div class="new_vip">
    <div class="content">
      <div class="options">
        <div v-if="allOrder !== 2">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="item in oils_options"
              :key="item.id"
              :label="item.name"
              :name="item.id"
              size="small"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <el-form :model="params" label-width="90px" size="small">
          <!-- 3.13修改顶部筛选 -->
          <el-form-item label="支付方式">
            <el-radio-group
              v-model="params.payment_code"
              size="small"
              @change="getData(1)"
            >
              <el-radio-button label="0">全部</el-radio-button>
              <el-popover
                width="100"
                placement="right"
                trigger="click"
                v-model="params.payment_code == 'xs'"
              >
                <el-checkbox
                  style="margin-bottom: 10px;"
                  :indeterminate="isIndeterminates"
                  checked
                  v-model="checkALL"
                  @change="handleCheckAllChange"
                >
                  全选
                </el-checkbox>
                <el-checkbox-group
                  v-model="pay_typeArr"
                  @change="handleCheckedCitiesChange"
                >
                  <el-checkbox
                    v-for="(item, index) in pay_type"
                    :key="index"
                    :label="item.code"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
                <el-radio-button slot="reference" label="xs">
                  线上支付
                </el-radio-button>
              </el-popover>

              <el-radio-button label="balance">余额支付</el-radio-button>
              <el-radio-button label="cash">现金支付</el-radio-button>
              <el-radio-button label="card_balance">加油卡支付</el-radio-button>
              <el-radio-button label="pos">pos终端</el-radio-button>
              <!-- <el-radio-button label="normal_allinpay">聚合支付</el-radio-button>
              <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
              <el-radio-button label="team_balance">车队卡</el-radio-button>
              <el-radio-button label="family_balance">亲属卡</el-radio-button>
            </el-radio-group>
            <span class="inline_title">订单状态</span>
            <el-radio-group
              v-model="params.pay_status"
              size="small"
              @change="getData(1)"
            >
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="2">已支付</el-radio-button>
              <el-radio-button label="1">未支付</el-radio-button>
              <el-radio-button label="3">冻结</el-radio-button>
              <el-radio-button label="4">已退款</el-radio-button>
              <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
            </el-radio-group>
            <el-checkbox
              v-if="uid == '' && allOrder !== 2"
              v-model="is_emp"
              label="员工订单"
              border
              class="emp_search"
            ></el-checkbox>
            <span v-if="uid == '' && allOrder !== 2">
              <span class="inline_title">今日加油</span>
              <el-input-number
                style="width: 80px;"
                :min="2"
                v-model="params.number"
                controls-position="right"
              ></el-input-number>
              次以上
              <el-button type="primary" @click="searchNum()">搜索</el-button>
            </span>
          </el-form-item>
          <el-form-item
            label="支付时间"
            v-if="allOrder !== 1 && allOrder !== 3"
          >
            <el-radio-group
              v-model="params.time"
              size="small"
              style="vertical-align: top; margin-right: 15px;"
              @change="changeTime"
            >
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">今天</el-radio-button>
              <el-radio-button label="2">昨天</el-radio-button>
              <el-radio-button label="7">最近7天</el-radio-button>
              <el-radio-button label="30">最近30天</el-radio-button>
              <el-radio-button label="m">本月</el-radio-button>
              <!-- <el-radio-button label="y">本年</el-radio-button> -->
              <el-radio-button label="z">自定义</el-radio-button>
              <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
            </el-radio-group>
            <el-date-picker
              v-model="dateValue[0]"
              type="date"
              class="date_picker_box"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              :disabled="params.time != 'z'"
              @change="cacheTime(1)"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[0]"
              :disabled="params.time != 'z'"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              @change="cacheTime(2)"
            ></el-time-picker>
            <span style="margin-right: 8px;">至</span>
            <el-date-picker
              v-model="dateValue[1]"
              type="date"
              class="date_picker_box"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :disabled="params.time != 'z'"
              @change="cacheTime(1)"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[1]"
              class="time_picker_box"
              :disabled="params.time != 'z'"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              @change="cacheTime(2)"
            ></el-time-picker>
            <el-button
              size="small"
              type="primary"
              v-show="params.time == 'z'"
              @click="timeSearch('search')"
            >
              搜索
            </el-button>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input
              class="input_box_small"
              v-model="params.ordersn"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchOrdersn()"
              ></el-button>
            </el-input>
            <span class="inline_title">门店</span>
            <el-select
              v-model="params.room_id"
              placeholder="请选择门店"
              class="options_input"
              size="small"
              clearable
              @change="getData(1)"
            >
              <el-option
                v-for="item in store_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="inline_title">操作员</span>
            <el-select
              v-model="params.emp_id"
              placeholder="请选择操作员"
              class="options_input"
              size="small"
              clearable
              @change="getData(1)"
            >
              <el-option
                v-for="item in emp_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="inline_title" v-if="allOrder !== 2">油枪</span>
            <el-select
              v-if="allOrder !== 2"
              v-model="params.cate_id"
              placeholder="请选择油枪"
              class="options_input"
              size="small"
              clearable
              @change="getData(1)"
            >
              <el-option
                v-for="item in equ_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="inline_title">来源</span>
            <el-select
              v-model="params.source"
              placeholder="请选择来源"
              class="options_input"
              size="small"
              clearable
              @change="getData(1)"
            >
              <el-option
                v-for="item in from_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              class="input_box_small"
              v-model="params.mobile"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchOrdersn()"
              ></el-button>
            </el-input>
            <span class="inline_title">实付金额区间</span>
            <el-input
              class="input_box_small"
              style="width: 130px;"
              v-model="params.amount_start"
              size="small"
              placeholder="开始金额"
            ></el-input>
            <span>---</span>
            <el-input
              class="input_box_small"
              style="width: 140px;"
              v-model="params.amount_end"
              size="small"
              placeholder="结束金额"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchOrdersn()"
              ></el-button>
            </el-input>
            <span class="inline_title">会员等级查询</span>
            <el-select
              v-model="params.user_level_id"
              placeholder="请选择会员等级"
              class="options_input"
              size="small"
              clearable
              @change="getData(1)"
            >
              <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠项">
            <el-checkbox-group v-model="discount_list" @change="check_discount">
              <el-checkbox label="platform_card">平台卡优惠</el-checkbox>
              <el-checkbox label="coupon_discount">优惠券优惠</el-checkbox>
              <el-checkbox label="point_discount">积分优惠</el-checkbox>
              <el-checkbox label="level_discount">会员优惠</el-checkbox>
              <el-checkbox label="recharge_discount">充值优惠</el-checkbox>
              <el-checkbox label="bonus_discount">红包优惠</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="stat_box">
      <div class="stat_item">
        <div class="stat_item_title">订单数量</div>
        <div class="stat_item_value">
          {{ statData.total_order }}
          <span>单</span>
        </div>
        <div class="stat_item_value" v-if="allOrder !== 2">
          {{ statData.total_num }}
          <span>升</span>
        </div>
      </div>
      <div class="stat_item2" v-if="allOrder !== 2">
        <div class="stat_item_title">订单金额</div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">应收</div>
            <div class="part_value" v-if="allOrder !== 2">
              {{ statData.total_money }}
              <span>元</span>
            </div>
            <div class="part_value" v-else>
              {{ statData.money }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">优惠</div>
            <div class="part_value" v-if="allOrder !== 2">
              {{
                (
                  Number(statData.total_money) - Number(statData.total_amount)
                ).toFixed(2)
              }}
              <span>元</span>
            </div>
            <div class="part_value" v-else>
              {{ statData.discount }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" v-if="allOrder !== 2">
            <div class="part_name">实收</div>
            <div class="part_value">
              {{ statData.total_amount }}
              <span>元</span>
            </div>
          </div>
          <div class="item_value_part" v-else>
            <div class="part_name">实收</div>
            <div class="part_value">
              {{ statData.amount }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">手续费</div>
            <div class="part_value">
              {{ statData.total_fee }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" v-if="allOrder !== 2">
            <div class="part_name">入账金额</div>
            <div class="part_value">
              {{
                (
                  Number(statData.total_amount || 0) -
                  Number(statData.total_fee || 0)
                ).toFixed(2)
              }}
              <span>元</span>
            </div>
          </div>
          <div class="item_value_part" v-else>
            <div class="part_name">入账金额</div>
            <div class="part_value">
              {{ statData.total_amount }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
      <div class="stat_item2" style="width: 90%;" v-else>
        <div class="stat_item_title">订单金额</div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">应收</div>
            <div class="part_value" v-if="allOrder !== 2">
              {{ statData.total_money || 0 }}
              <span>元</span>
            </div>
            <div class="part_value" v-else>
              {{ statData.money || 0 }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">优惠</div>
            <div class="part_value" v-if="allOrder !== 2">
              {{
                (
                  Number(statData.total_money || 0) -
                  Number(statData.total_amount || 0)
                ).toFixed(2)
              }}
              <span>元</span>
            </div>
            <div class="part_value" v-else>
              {{ statData.discount || 0 }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" v-if="allOrder !== 2">
            <div class="part_name">实收</div>
            <div class="part_value">
              {{ statData.total_amount || 0 }}
              <span>元</span>
            </div>
          </div>
          <div class="item_value_part" v-else>
            <div class="part_name">实收</div>
            <div class="part_value">
              {{ statData.amount || 0 }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4;">
            <div class="part_name">手续费</div>
            <div class="part_value">
              {{ statData.fee || 0 }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part" v-if="allOrder !== 2">
            <div class="part_name">入账金额</div>
            <div class="part_value">
              {{
                (
                  Number(statData.total_amount || 0) -
                  Number(statData.total_fee || 0)
                ).toFixed(2)
              }}
              <span>元</span>
            </div>
          </div>
          <div class="item_value_part" v-else>
            <div class="part_name">入账金额</div>
            <div class="part_value">
              {{ Number(statData.total_amount || 0).toFixed(2) }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
      <div class="stat_item3" v-if="allOrder !== 2">
        <div class="stat_item_title">支付方式</div>
        <div class="stat_item_value3">
          <div class="item_value_part">
            <!-- <div class="part_title4">银联</div> -->
            <div class="part_value">
              <span>银联</span>
              {{ statData.unionpay }}
              <span>元</span>
            </div>
            <div class="part_value">
              <span>加油卡</span>
              {{ statData.card_balance }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_value">
              <span>现金</span>
              {{ statData.cash }}
              <span>元</span>
            </div>
            <div class="part_value">
              <span>家庭卡</span>
              {{ statData.family_balance }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_value">
              <span>余额</span>
              {{ statData.balance }}
              <span>元</span>
            </div>
            <div class="part_value">
              <span>车队卡</span>
              {{ statData.team_balance }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="allOrder != 5">
        <!-- <el-button type="primary" size="small" @click="search()">查询</el-button> -->
        <!-- <el-button size="small" @click="clearAll()">清空</el-button> -->
        <!-- <el-button size="small">打印</el-button> -->
        <el-button
          size="small"
          type="primary"
          @click="exportList()"
          v-if="allOrder !== 1 && allOrder !== 3"
        >
          导出
        </el-button>
        <el-button size="small" type="primary" @click="batchDetele(2)">
          批量删除
        </el-button>
        <el-button size="small" type="primary" @click="batchDetele(3)">
          时间段删除
        </el-button>
        <el-button size="small" type="primary" @click="refresh()">
          刷新
        </el-button>
        <!-- <el-button
					size="small"
					type="warning"
					@click="showCancelCashOrder = true"
					>已作废订单</el-button
        >-->
        <!-- <el-button size="small" type="danger" @click="errorOrder()">异常订单</el-button> -->
        <el-badge
          :value="receiptNum"
          class="item"
          style="margin-left: 10px; margin-top: -2px;"
        >
          <el-button size="small" type="success" @click="showReceiptOrder()">
            开票订单
          </el-button>
        </el-badge>
        <el-badge
          :value="cashTotal"
          class="item"
          style="margin-left: 20px; margin-top: -2px;"
        >
          <el-button size="small" type="danger" @click="cashConfirmOrder()">
            现金待确认
          </el-button>
        </el-badge>
        <div style="display: inline-block; width: 200px; height: 30px;"></div>
        <!-- <el-badge :value="cashTotal" class="item" style="margin-left:10px"> -->
        <!-- </el-badge> -->
        <div style="float: right; margin-right: 10px; display: flex;">
          <div style="width: 200px; height: 30px;" @click="isShow_order"></div>
          <el-popover placement="bottom" width="120" trigger="click">
            <el-checkbox
              style="margin-bottom: 10px;"
              v-for="(item, index) in showTableItems"
              :key="index"
              v-model="item.show"
            >
              {{ item.name }}
            </el-checkbox>
            <el-button
              slot="reference"
              size="small"
              icon="el-icon-s-unfold"
            ></el-button>
          </el-popover>
        </div>
      </div>
      <div v-else>
        <el-button size="small" type="primary" @click="recoverOrdered(2)">
          批量恢复
        </el-button>
        <el-button size="small" type="primary" @click="recoverOrdered(3)">
          时间段恢复
        </el-button>
        <el-button size="small" type="primary" @click="refresh()">
          刷新
        </el-button>
      </div>
      <div class="table_box" id="printbox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="setTableHeader"
          element-loading-text="正在查询..."
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" fixed></el-table-column>
          <el-table-column
            label="消费单号"
            prop="ordersn"
            v-if="showTableItems[0].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="会员卡号"
            prop="card.card_num"
            v-if="showTableItems[1].show && allOrder !== 2"
            align="center"
          ></el-table-column>
          <el-table-column
            label="会员名称"
            prop="user.real_name"
            v-if="showTableItems[2].show"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="rowClick(scope.row.card.uid)">
                  {{ scope.row.user.real_name }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="手机号码"
            prop="user.mobile"
            v-if="showTableItems[3].show"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="rowClick(scope.row.card.uid)">
                  {{ scope.row.user.mobile }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="油枪号"
            prop="show_catename"
            v-if="showTableItems[4].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="油品编号"
            prop
            v-if="showTableItems[5].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="油品"
            prop="show_goodsname"
            v-if="showTableItems[6].show && allOrder !== 2"
            align="center"
          ></el-table-column>
          <el-table-column
            label="升数"
            prop="num"
            v-if="showTableItems[7].show && allOrder !== 2"
            align="center"
          ></el-table-column>
          <el-table-column label="应收金额" prop="money"></el-table-column>
          <el-table-column
            label="实付金额"
            prop="amount"
            v-if="showTableItems[8].show"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.amount }}
                <el-button
                  type="text"
                  style="padding: 0;"
                  @click="MoneyDetail(scope.row)"
                >
                  详情
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="手续费"
            prop="fee"
            align="center"
            v-if="showTableItems[19].show"
          ></el-table-column>
          <el-table-column
            label="入账金额"
            align="center"
            v-if="showTableItems[20].show"
          >
            <template slot-scope="scope">
              <span>
                {{
                  (Number(scope.row.amount) - Number(scope.row.fee)).toFixed(2)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="赠送积分"
            prop="take_point"
            v-if="showTableItems[18].show && allOrder !== 2"
            align="center"
          ></el-table-column>
          <el-table-column
            label="状态"
            v-if="showTableItems[9].show"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.show_status }}
                <el-button
                  type="text"
                  style="padding: 0;"
                  v-if="
                    scope.row.allow_pay == '1' &&
                      scope.row.payment_code == 'cash'
                  "
                  @click="confirmOrderItem(scope.row.ordersn, 1, 'cash')"
                >
                  确认
                </el-button>
                <!-- <el-button type="text"  style="padding:0" v-if="scope.row.allow_pay=='1'&&scope.row.source == 'pos'&&scope.row.payment_code=='unionpay'" @click="confirmOrderItem(scope.row.ordersn,1,'unionpay')">确认</el-button>
                <el-button type="text"  style="padding:0" v-if="scope.row.allow_pay=='1'&&scope.row.source == 'pos'&&scope.row.payment_code==null" @click="confirmOrderItem(scope.row.ordersn,1,'unionpay')">确认</el-button>-->
                <el-button
                  type="text"
                  style="padding: 0; color: #f56c6c;"
                  v-if="
                    scope.row.allow_pay == '1' &&
                      scope.row.payment_code == 'cash'
                  "
                  @click="confirmOrderItem(scope.row.ordersn, 2)"
                >
                  取消
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="支付方式"
            v-if="showTableItems[10].show"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.show_payway }}</div>
              <!-- <div>{{scope.row.show_payfrom}}</div> -->
            </template>
          </el-table-column>
          <el-table-column
            label="下单时间"
            width="99px"
            prop="create_time"
            v-if="showTableItems[11].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="支付时间"
            width="99px"
            prop="show_payTime"
            v-if="showTableItems[11].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作员"
            prop="show_empname"
            v-if="showTableItems[12].show"
            align="center"
          ></el-table-column>
          <!-- <el-table-column label="所属分店" prop="last_time"></el-table-column> -->
          <el-table-column
            label="消费门店"
            prop="room.name"
            v-if="showTableItems[13].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="子卡卡号"
            prop="last_time"
            v-if="showTableItems[14].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="子卡名称"
            prop="last_time"
            v-if="showTableItems[15].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="来源"
            prop="show_from"
            v-if="showTableItems[16].show"
            align="center"
          ></el-table-column>
          <el-table-column
            label="备注"
            prop="message"
            v-if="showTableItems[17].show"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="180">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <div
                  v-if="scope.row.pay_status != 1 && allOrder != 5"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-warning"
                    @click="refundShow(scope.row)"
                  >
                    订单退款
                  </el-button>
                </div>
                <div
                  v-if="canViewInvoice(scope.row) || canOpenInvoice(scope.row)"
                  class="operation-btn"
                >
                  <el-button
                    v-if="canViewInvoice(scope.row)"
                    type="text"
                    class="action-button action-button-primary"
                    @click="show_invoic(scope.row)"
                  >
                    查看发票
                  </el-button>
                  <el-button
                    v-else-if="canOpenInvoice(scope.row)"
                    type="text"
                    class="action-button action-button-primary"
                    @click="open_invoice(scope.row)"
                  >
                    开具发票
                  </el-button>
                </div>
                <div
                  v-if="scope.row.order_query == 1 && allOrder != 5"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-info"
                    @click="Query_status(scope.row)"
                  >
                    状态查询
                  </el-button>
                </div>
                <div
                  v-if="scope.row.pay_status != 1 && allOrder != 5"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-success"
                    @click="printReceipt(scope.row.id)"
                  >
                    打印小票
                  </el-button>
                </div>
                <div class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-info"
                    @click="isMessage(scope.row)"
                  >
                    订单备注
                  </el-button>
                </div>
                <div v-if="allOrder == 5" class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-success"
                    @click="recoverOrdered(1, scope.row.id)"
                  >
                    订单恢复
                  </el-button>
                </div>
                <div v-if="allOrder != 5" class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-danger"
                    @click="batchDetele(1, scope.row.id)"
                  >
                    删除订单
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="page">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="showErrorOrder"
      title="异常订单"
      @close="showErrorOrder = false"
      width="820px"
    >
      <div class="dialog_option">
        <div class="options_item">
          <span class="item_label">状态</span>
          <el-select
            v-model="errorParams.status"
            class="select_box"
            size="small"
            clearable
          >
            <el-option label="未处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </div>
        <div class="options_item">
          <span class="item_label">支付方式</span>
          <el-select
            v-model="errorParams.payment_code"
            class="select_box"
            size="small"
            clearable
          >
            <el-option
              v-for="item in paymentOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="options_item">
          <span class="item_label">时间</span>
          <el-date-picker
            clearable
            v-model="errorParams.timeValue"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            size="small"
            style="width: 300px;"
          ></el-date-picker>
        </div>
        <div class="button_line">
          <el-button type="primary" size="small" @click="errorOrder()">
            查询
          </el-button>
          <el-button size="small" @click="clearErrorParams()">清空</el-button>
          <el-button size="small" @click="changeErrorStatus(1)">
            改为已处理
          </el-button>
          <el-button size="small" @click="changeErrorStatus(0)">
            改为未处理
          </el-button>
          <el-button size="small" @click="delErrorOrder()" type="danger">
            删除
          </el-button>
        </div>
      </div>
      <div style="margin: 15px 0;">
        <el-table
          :data="errorOrderList"
          border
          @selection-change="handleSelectionChange"
          size="small"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            label="支付方式"
            prop="show_payway"
          ></el-table-column>
          <el-table-column label="支付金额" prop="pay_money"></el-table-column>
          <el-table-column label="支付时间" prop="show_time"></el-table-column>
          <el-table-column label="状态" prop="show_status"></el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          layout="prev, pager, next"
          :current-page="errorPage"
          :total="errorTotal"
          :page-size="10"
          background
          @current-change="handleCurrentChangeError"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 确认订单 -->
    <el-dialog
      :visible.sync="showConfirmOrder"
      @close="showConfirmOrder = false"
      title="确认支付"
      width="400px"
    >
      <div class="align_c" style="margin-top: -15px;">
        支付方式：
        <el-select
          size="small"
          v-model="confirmData.type"
          style="width: 180px; margin-right: 15px;"
        >
          <el-option
            v-for="item in handlePay"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="confirmOrderSubmit()"
        >
          确认
        </el-button>
      </div>
      <!-- <div class="align_c" style="margin-top:15px"><el-button size="small" type="primary" @click="confirmOrderSubmit()">确认</el-button></div> -->
    </el-dialog>
    <!-- 取消订单 -->
    <el-dialog
      :visible.sync="showCancelOrder"
      @close="showCancelOrder = false"
      title="取消订单"
      width="400px"
    >
      <div style="margin-bottom: 20px;">订单号：{{ confirmData.ordersn }}</div>
      <div>
        <el-button
          style="width: 100%;"
          type="danger"
          size="samll"
          :loading="submitLoading"
          @click="cancelOrderSubmit()"
        >
          取消订单
        </el-button>
      </div>
      <!-- <div class="align_c" style="margin-top:15px"><el-button size="small" type="primary" @click="confirmOrderSubmit()">确认</el-button></div> -->
    </el-dialog>
    <!-- 收款详情 -->
    <el-dialog
      :visible.sync="showMoneyDetail"
      @close="showMoneyDetail = false"
      title="收款详情"
      width="300px"
    >
      <el-form :model="moneyDetailMsg" size="small" label-width="120px">
        <el-form-item label="原价">{{ moneyDetailMsg.money }}</el-form-item>
        <el-form-item label="会员优惠">
          {{ moneyDetailMsg.dec_discount_money }}
        </el-form-item>
        <el-form-item label="优惠券优惠">
          {{ moneyDetailMsg.dec_coupon_money }}
        </el-form-item>
        <el-form-item label="积分抵扣">
          {{ moneyDetailMsg.dec_point_money }}
        </el-form-item>
        <el-form-item label="充值优惠">
          {{ moneyDetailMsg.pay_discount }}
        </el-form-item>
        <el-form-item label="平台优惠">
          {{ moneyDetailMsg.platform_discount || "0.00" }}
        </el-form-item>
        <el-form-item label="实际收款">
          {{ moneyDetailMsg.amount }}
        </el-form-item>
        <el-form-item label="红包抵扣">
          {{ moneyDetailMsg.bonus_dec_money || "0.00" }}
        </el-form-item>
        <div v-if="moneyDetailMsg.is_rounding">
          <el-form-item label="现金凑整">
            {{ moneyDetailMsg.numValue }}
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="showCashConfirm"
      title="现金待确认订单"
      @close="closeCashConfirm()"
      width="80%"
    >
      <el-input
        clearable
        style="width: 300px; margin-bottom: 20px;"
        placeholder="手机号检索"
        v-model="mobile"
      >
        <el-button slot="append" @click="getCashData">搜索</el-button>
      </el-input>
      <el-table
        :data="cashConfirmData"
        border
        v-loading="cashLoading"
        element-loading-text="正在查询..."
      >
        <el-table-column
          label="消费单号"
          prop="ordersn"
          align="center"
        ></el-table-column>
        <el-table-column
          label="会员卡号"
          prop="card.card_num"
          align="center"
        ></el-table-column>
        <el-table-column label="会员名称" prop="user.real_name" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="rowClick(scope.row.card.uid)">
                {{ scope.row.user.real_name }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号码" prop="user.mobile" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="rowClick(scope.row.card.uid)">
                {{ scope.row.user.mobile }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="油品"
          prop="show_goodsname"
          align="center"
        ></el-table-column>
        <el-table-column
          label="升数"
          prop="num"
          align="center"
        ></el-table-column>
        <el-table-column
          label="应收金额"
          prop="money"
          align="center"
        ></el-table-column>
        <el-table-column
          label="下单时间"
          width="99px"
          prop="create_time"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作员"
          prop="show_empname"
          align="center"
        ></el-table-column>
        <el-table-column
          label="来源"
          prop="show_from"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="98px">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="padding: 0;"
              v-if="
                scope.row.allow_pay == '1' && scope.row.payment_code == 'cash'
              "
              @click="confirmOrderItem(scope.row.ordersn, 1, 'cash')"
            >
              确认
            </el-button>
            <el-button
              type="text"
              style="padding: 0; color: #f56c6c;"
              v-if="
                scope.row.allow_pay == '1' && scope.row.payment_code == 'cash'
              "
              @click="confirmOrderItem(scope.row.ordersn, 2)"
            >
              取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination
          layout="prev, pager, next, total"
          :current-page="cashPage"
          :total="cashTotal"
          :page-size="10"
          background
          @current-change="getCashData"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showReceipt" title="开票订单" width="80%">
      <receipt-order :allOrder="allOrder" @refresh="refresh"></receipt-order>
    </el-dialog>
    <!-- <el-dialog
			:visible.sync="showCancelCashOrder"
			title="已作废现金订单"
			width="80%"
		>
			<cancal-order ref="cancalCashOrder"></cancal-order>
    </el-dialog>-->
    <!-- 批量删除 -->
    <el-dialog
      title="删除操作"
      :visible.sync="batchShow"
      @close="closeBatchPopup"
      width="700px"
    >
      <div v-if="deleteForm.status == '3'">
        时间范围：
        <el-date-picker
          v-model="dateValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="dateValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
        <span style="margin-right: 8px;">至</span>
        <el-date-picker
          v-model="timeValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
      </div>
      <div
        style="display: flex; margin-bottom: 10px;"
        v-if="deleteForm.is_verification"
      >
        <!--  v-if="deleteForm.is_verification" -->
        <div>验证码：</div>
        <el-input v-model="deleteForm.code" style="width: 220px;">
          <template slot="append">
            <el-link :disabled="btn_status" @click="getCode" type="primary">
              {{ code_text }}
            </el-link>
          </template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBatchPopup">取 消</el-button>
        <el-button type="primary" @click="FakeOrder(1)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除恢复"
      :visible.sync="batchShows"
      @close="closeBatchPopup"
      width="700px"
    >
      <div v-if="deleteForm.status == '3'">
        时间范围：
        <el-date-picker
          v-model="dateValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="dateValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
        <span style="margin-right: 8px;">至</span>
        <el-date-picker
          v-model="timeValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
      </div>
      <div
        style="display: flex; margin-bottom: 10px;"
        v-if="deleteForm.is_verification"
      >
        <!--  v-if="deleteForm.is_verification" -->
        <div>验证码：</div>
        <el-input v-model="deleteForm.code" style="width: 220px;">
          <template slot="append">
            <el-link :disabled="btn_status" @click="getCode" type="primary">
              {{ code_text }}
            </el-link>
          </template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBatchPopup">取 消</el-button>
        <el-button type="primary" @click="FakeOrder(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退款操作"
      :visible.sync="refundIsShow"
      @close="closeRefund"
      width="700px"
    >
      <el-form label-width="auto">
        <div style="margin-bottom: 10px;">退款单号: {{ refund.ordersn }}</div>
        <div style="margin-bottom: 10px;" v-if="allOrder !== 2">
          订单油品: {{ refund.name }}
        </div>
        <div style="margin-bottom: 10px;">退款金额: {{ refund.money }}</div>
        <el-form-item label="退款原因">
          <el-input
            v-model="refund.desc"
            placeholder="请输入退款原因"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          v-if="allOrder == 0 && config.open_refund_order == 1"
        >
          <el-input
            placeholder="请输入"
            v-model="refund.verification_code"
            style="width: 220px;"
          >
            <template slot="append">
              <el-link :disabled="btn_status" @click="getCode" type="primary">
                {{ code_text }}
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          v-if="allOrder == 1 && config.open_refund_order == 1"
        >
          <el-input
            placeholder="请输入"
            v-model="refund.verification_code"
            style="width: 220px;"
          >
            <template slot="append">
              <el-link :disabled="btn_status" @click="getCode" type="primary">
                {{ code_text }}
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          v-if="allOrder == 2 && config.open_refund_normal == 1"
        >
          <el-input
            placeholder="请输入"
            v-model="refund.verification_code"
            style="width: 220px;"
          >
            <template slot="append">
              <el-link :disabled="btn_status" @click="getCode" type="primary">
                {{ code_text }}
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeRefund">取 消</el-button>
          <el-button type="primary" @click="refundSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="invoiceReissueMode ? '开具发票' : '查看发票'"
      :visible.sync="checkInvoice"
      width="700px"
      @close="closeCheckInvoice"
    >
      <div v-if="!invoiceReissueMode" class="invoice-preview">
        <div class="invoice-preview-header">
          <div class="invoice-preview-title">
            <div class="invoice-preview-name">
              {{ formatInvoiceDisplay(invoiceForm.buyerName) }}
            </div>
            <div class="invoice-preview-meta">
              <span>{{ getInvoiceTitleTypeLabel(invoiceForm.titleType) }}</span>
              <span class="invoice-preview-dot">/</span>
              <span>{{ getInvoicePersonTypeLabel(invoiceForm.type_person) }}</span>
            </div>
          </div>
          <el-tag size="small" type="success">已开票</el-tag>
        </div>
        <div class="invoice-preview-grid">
          <div class="invoice-preview-item">
            <div class="invoice-preview-label">发票类型</div>
            <div class="invoice-preview-value">
              {{ getInvoiceTitleTypeLabel(invoiceForm.titleType) }}
            </div>
          </div>
          <div class="invoice-preview-item">
            <div class="invoice-preview-label">抬头类型</div>
            <div class="invoice-preview-value">
              {{ getInvoicePersonTypeLabel(invoiceForm.type_person) }}
            </div>
          </div>
          <div class="invoice-preview-item invoice-preview-item-wide">
            <div class="invoice-preview-label">发票抬头</div>
            <div class="invoice-preview-value">
              {{ formatInvoiceDisplay(invoiceForm.buyerName) }}
            </div>
          </div>
          <template v-if="invoiceForm.type_person === 2">
            <div class="invoice-preview-item invoice-preview-item-wide">
              <div class="invoice-preview-label">纳税人识别号</div>
              <div class="invoice-preview-value">
                {{ formatInvoiceDisplay(invoiceForm.taxNo) }}
              </div>
            </div>
            <div class="invoice-preview-item invoice-preview-item-wide">
              <div class="invoice-preview-label">单位地址</div>
              <div class="invoice-preview-value">
                {{ formatInvoiceDisplay(invoiceForm.companyAddress) }}
              </div>
            </div>
            <div class="invoice-preview-item">
              <div class="invoice-preview-label">公司电话</div>
              <div class="invoice-preview-value">
                {{ formatInvoiceDisplay(invoiceForm.companyTel) }}
              </div>
            </div>
            <div class="invoice-preview-item">
              <div class="invoice-preview-label">开户银行</div>
              <div class="invoice-preview-value">
                {{ formatInvoiceDisplay(invoiceForm.bank) }}
              </div>
            </div>
            <div class="invoice-preview-item invoice-preview-item-wide">
              <div class="invoice-preview-label">银行账号</div>
              <div class="invoice-preview-value">
                {{ formatInvoiceDisplay(invoiceForm.account) }}
              </div>
            </div>
          </template>
          <div class="invoice-preview-item">
            <div class="invoice-preview-label">邮箱</div>
            <div class="invoice-preview-value">
              {{ formatInvoiceDisplay(invoiceForm.email) }}
            </div>
          </div>
          <div class="invoice-preview-item">
            <div class="invoice-preview-label">订单号</div>
            <div class="invoice-preview-value">
              {{ formatInvoiceDisplay(invoiceCurrentRow && invoiceCurrentRow.ordersn) }}
            </div>
          </div>
          <div class="invoice-preview-item invoice-preview-item-wide">
            <div class="invoice-preview-label">留言</div>
            <div class="invoice-preview-value invoice-preview-remark">
              {{ formatInvoiceDisplay(invoiceForm.remark) }}
            </div>
          </div>
        </div>
        <div class="invoice-preview-actions">
          <el-button @click="down_invoice">下载发票</el-button>
          <el-button
            type="primary"
            :loading="invoiceLoading"
            @click="confirmReissue"
          >
            重新开具
          </el-button>
        </div>
      </div>
      <el-form
        v-else
        :model="invoiceForm"
        :rules="invoiceRules"
        ref="invoiceReissueFormRef"
        label-width="110px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票类型" prop="titleType">
              <el-select
                v-model="invoiceForm.titleType"
                placeholder="请选择发票类型"
                style="width: 100%;"
              >
                <el-option label="电子普通发票" value="1"></el-option>
                <el-option
                  v-if="invoiceForm.type_person !== 1"
                  label="电子专用发票"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型" prop="type_person">
              <el-radio-group
                v-model="invoiceForm.type_person"
                @change="onTitleTypeChange"
              >
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="发票抬头" prop="buyerName">
          <el-input
            v-model="invoiceForm.buyerName"
            placeholder="请填写发票抬头"
          ></el-input>
        </el-form-item>
        <template v-if="invoiceForm.type_person === 2">
          <el-form-item label="纳税人识别号" prop="taxNo">
            <el-input
              v-model="invoiceForm.taxNo"
              placeholder="请填写纳税人识别号"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位地址" prop="companyAddress">
            <el-input
              v-model="invoiceForm.companyAddress"
              placeholder="请填写单位地址"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司电话" prop="companyTel">
                <el-input
                  v-model="invoiceForm.companyTel"
                  placeholder="请填写公司电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行" prop="bank">
                <el-input
                  v-model="invoiceForm.bank"
                  placeholder="请填写开户银行"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="银行账号" prop="account">
            <el-input
              v-model="invoiceForm.account"
              placeholder="请填写银行账号"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="invoiceForm.email"
            placeholder="请填写邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="留言" prop="remark">
          <el-input
            v-model="invoiceForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请填写留言"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="invoiceSubmitLoading"
            @click="submitInvoice"
          >
            确定重开
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="开具发票"
      :visible.sync="showInvoice"
      width="700px"
      @close="closeInvoice"
    >
      <el-form
        :model="invoiceForm"
        :rules="invoiceRules"
        ref="invoiceFormRef"
        label-width="110px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票类型" prop="titleType">
              <el-select
                v-model="invoiceForm.titleType"
                placeholder="请选择发票类型"
                style="width: 100%;"
              >
                <el-option label="电子普通发票" value="1"></el-option>
                <el-option
                  v-if="invoiceForm.type_person !== 1"
                  label="电子专用发票"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型" prop="type_person">
              <el-radio-group
                v-model="invoiceForm.type_person"
                @change="onTitleTypeChange"
              >
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="发票抬头" prop="buyerName">
          <el-input
            v-model="invoiceForm.buyerName"
            placeholder="请填写发票抬头"
          ></el-input>
        </el-form-item>
        <template v-if="invoiceForm.type_person === 2">
          <el-form-item label="纳税人识别号" prop="taxNo">
            <el-input
              v-model="invoiceForm.taxNo"
              placeholder="请填写纳税人识别号"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位地址" prop="companyAddress">
            <el-input
              v-model="invoiceForm.companyAddress"
              placeholder="请填写单位地址"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司电话" prop="companyTel">
                <el-input
                  v-model="invoiceForm.companyTel"
                  placeholder="请填写公司电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行" prop="bank">
                <el-input
                  v-model="invoiceForm.bank"
                  placeholder="请填写开户银行"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="银行账号" prop="account">
            <el-input
              v-model="invoiceForm.account"
              placeholder="请填写银行账号"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="invoiceForm.email"
            placeholder="请填写邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="留言" prop="remark">
          <el-input
            v-model="invoiceForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请填写留言"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeInvoice">取 消</el-button>
          <el-button
            type="primary"
            :loading="invoiceLoading"
            @click="submitInvoice"
          >
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="订单备注" :visible.sync="showMsg" width="700px">
      <el-form label-width="auto">
        <el-form-item label="备注">
          <el-input
            v-model="msg"
            placeholder="请输入"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="showMsg = false">取 消</el-button>
          <el-button type="primary" @click="Submit_msg">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_safeinfo,
  SendAdminCode,
  get_search_biz_user_id,
} from "@/api/set";
import { getConfigButtonStatus } from "@/api/user";
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee";
import ReceiptOrder from "./receiptOrder";
import CancalOrder from "./cancalCashOrder";
import {
  cancelOrder,
  confirmOrder,
  deleteFakeOrder,
  employeeOptions,
  equipmentOptions,
  errorOrderDel,
  errorOrderStatus,
  exportMethod,
  goodsOptions,
  last_shift_lists,
  normal_order_Query,
  normalOrder_refund,
  normalOrder_refundStatus,
  offline_order_query,
  offline_order_status,
  offline_orderRefund,
  oilsErrorOrder,
  oilsOrder,
  orderPrint,
  vipList,
  vipOrderListNow,
  vipOrdinaryList,
  print_normal_order,
  setVipRemark,
  getVipRemark
} from "@/api/vip";
import {
  offline_order_msg,
  normal_order_msg,
  open_invoiceNo,
  get_invoice_detail
} from "@/api/user";
import { deleteOrderList, recoverOrder, deleteOrder_pt } from "@/api/order";

const createInvoiceForm = () => ({
  type: 3,
  type_person: 1,
  titleType: "1",
  buyerName: "",
  taxNo: "",
  companyAddress: "",
  companyTel: "",
  bank: "",
  account: "",
  email: "",
  remark: ""
});

export default {
  components: {
    ReceiptOrder,
    CancalOrder,
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    allOrder: {
      //所有订单/当前班次订单
      type: Number,
      default: 0,
    },
  },
  watch: {
    uid(val) {
      console.log(val);
      this.getData();
    },
  },
  data() {
    return {
      discount_list: [],
      tlPaysearchs: [],
      batchShows: false,
      isIndeterminates: false,
      checkALL: false,
      visible: false,
      pay_typeArr: [
        "wxpay",
        "alipay",
        "fuiou",
        "unionpay",
        "normal_allinpay",
        "lakala",
        "leshua"
      ],
      pay_type: [
        {
          code: "wxpay",
          name: "微信支付",
        },
        {
          code: "alipay",
          name: "支付宝支付",
        },
        {
          code: "fuiou",
          name: "闪付",
        },
        {
          code: "unionpay",
          name: "银联支付",
        },
        {
          code: "normal_allinpay",
          name: "聚合支付",
        },
        {
          code: "lakala",
          name: "快捷支付",
        },
        {
          code: "leshua",
          name: "乐付",
        },
      ],
      mobile: "",
      refund: {
        desc: "",
        ordersn: "",
        money: "",
        name: "",
        verification_code: "",
      },
      refundIsShow: false,
      deleteForm: {
        status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
        id: "",
        code: "", //验证码
        is_verification: true,
      },
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      loading: false, //页面loading
      activeName: "0", //顶部标签页选择项
      ifAllSearch: true, //是否包含散客
      showAllList: false, //是否显示未支付订单
      formData: {},
      params: {
        //查询参数
        // card_num: "", //会员卡号
        ordersn: "", //订单编号
        user_level_id: "", //等级id
        room_id: "", //门店id
        emp_id: "", //员工id
        cate_id: "", //油枪id
        payment_code: "0", //支付方式
        time: "30", //创建时间
        pay_status: "2", //订单状态 1.未支付 2.已支付 3.冻结
        number: 2, //多次加油次数
        source: "", // 来源
      },
      goods_id: "0", //消费油品
      dateValue: [], //消费时间
      timeValue: [],
      store_options: [], //店铺选择项
      level_options: [], //会员等级选择项
      emp_options: [], //员工选择项
      equ_options: [], //油枪选择项
      oils_options: [{ id: "0", name: "全部" }], //油品选择项
      from_options: [
        { id: "wx", name: "微信" },
        { id: "h5", name: "支付宝" },
        { id: "wxapp", name: "微信小程序" },
        { id: "aliapp", name: "支付宝小程序" },
        { id: "pos", name: "pos终端机" },
        { id: "pc", name: "后台" },
        { id: "hand", name: "手持终端" },
        { id: "ruyi", name: "如意" },
        { id: "ali", name: "支付宝" },
      ], //来源选择项
      tableData: [], //表格数据
      page: 1, //页码
      total: 0, //总数
      showErrorOrder: false, //显示异常订单
      errorOrderList: [], //异常订单列表
      errorPage: 1, //异常订单页码
      errorTotal: 0, //异常订单总数
      multipleSelection: [], //表格多选
      errorParams: {
        status: "", //状态
        timeValue: [], //时间
        payment_code: "", //支付方式
        pay_money: "", //金额
        opt: ">", //金额
      }, //异常订单筛选项
      showConfirmOrder: false, //确认未支付订单弹窗
      showCancelOrder: false, //取消未支付订单弹窗
      is_emp: false, //员工自己扫码的订单
      confirmData: {}, // 确认未支付订单信息
      searchNumber: false, //是否是查询多次交易的客户
      paymentOptions: [
        //支付方式选项
        { name: "银联支付", value: "unionpay" },
        { name: "余额支付", value: "balance" },
        // {name: "微信支付", value: "wxpay"},
        { name: "支付宝免签", value: "single_alipay" },
        { name: "微信免签", value: "single_wxpay" },
      ],
      statData: {},
      showMoneyDetail: false, //显示价格详情
      moneyDetailMsg: {}, // 价格详情
      pickerOptions: {
        //时间快捷选项
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      showTableItems: [
        { name: "消费单号", show: true },
        { name: "会员卡号", show: true },
        { name: "会员名称", show: false },
        { name: "手机号码", show: true },
        { name: "油枪号", show: false },
        { name: "油品编号", show: false },
        { name: "油品", show: true },
        { name: "升数", show: true },
        { name: "实付金额", show: true },
        { name: "状态", show: true },
        { name: "支付方式", show: true },
        { name: "消费时间", show: true },
        { name: "操作员", show: true },
        { name: "消费分店", show: false },
        { name: "子卡卡号", show: false },
        { name: "子卡名称", show: false },
        { name: "来源", show: true },
        { name: "备注", show: false },
        { name: "赠送积分", show: true },
        { name: "手续费", show: true },
        { name: "入账金额", show: true },
      ],
      tableLoading: false, //表格loading
      submitLoading: false, // 确认、取消订单loading
      handlePay: [{ label: "现金", value: "cash" }],
      cashConfirmData: [], // 现金待确认订单数据
      cashPage: 1, // 现金待确认订单分页
      cashTotal: 0, // 现金待确认订单总数
      showCashConfirm: false, // 现金带确认订单弹窗
      cashLoading: false, // 现金待确认订单加载loading
      is_cash: false, // 现金待确认订单 确认/取消后判断刷新方法
      showReceipt: false, // 开票订单弹窗
      receiptNum: 0, // 待开票订单数量
      refreshData: true, // 是否需要获取统计数据
      showCancelCashOrder: false, // 已作废订单弹窗
      dateValueFake: [], //消费时间
      timeValueFake: [],
      batchShow: false,
      config: {},
      IsShow: 0,
      times: null,
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.value2 != "") {
            return time.getTime() > Date.now() || time.getTime() > this.value2;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.value1 || time.getTime() > Date.now();
        },
      },
      showInvoice: false,
      checkInvoice: false,
      invoiceReissueMode: false,
      invoiceLoading: false,
      invoiceSubmitLoading: false,
      invoiceSubmitTimer: null,
      invoiceButtonVisible: true,
      invoiceForm: createInvoiceForm(),
      invoiceCurrentRow: null,
      invoiceRules: {
        titleType: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
        buyerName: [
          { required: true, message: "请填写发票抬头", trigger: "blur" }
        ],
        taxNo: [
          { required: true, message: "请填写纳税人识别号", trigger: "blur" }
        ],
        companyAddress: [
          { required: true, message: "请填写单位地址", trigger: "blur" }
        ],
        companyTel: [
          { required: true, message: "请填写公司电话", trigger: "blur" }
        ],
        bank: [
          { required: true, message: "请填写开户银行", trigger: "blur" }
        ],
        account: [
          { required: true, message: "请填写银行账号", trigger: "blur" }
        ],
        email: [
          { type: "email", message: "请填写正确的邮箱格式", trigger: "blur" }
        ]
      },
      showMsg: false,
      ordersn: "",
      msg: "",
    };
  },
  // created(){
  //   console.log('create')
  //   this.getData();
  // },
  mounted() {
    console.log("key", this.allOrder);
    this.init();
    this.getInvoiceButtonConfig();
    // this.getCashData();
    this.get_detail();
    console.log("2222", this.moneyDetailMsg);
    setTimeout(() => {
      this.getData();
    }, 200);
  },
  methods: {
    check_discount(e) {
      console.log(e);
      this.getData(1);
    },
    async Submit_msg() {
      if (this.allOrder == 2) {
        const res = await normal_order_msg({
          app_id: this.app_id,
          ordersn: this.ordersn,
          message: this.msg,
        });
        if (res.code == 200) {
          this.$message.success("备注成功");
          (this.showMsg = false), (this.ordersn = "");
          this.getData(1);
        } else {
          this.$message.error(res.msg);
        }
      } else {
        const res = await offline_order_msg({
          app_id: this.app_id,
          ordersn: this.ordersn,
          message: this.msg,
        });
        if (res.code == 200) {
          this.$message.success("备注成功");
          (this.showMsg = false), (this.ordersn = "");
          this.getData(1);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    isMessage(row) {
      this.showMsg = true;
      this.msg = row.message
      this.ordersn = row.ordersn;
    },
    //点击恢复订单
    isShow_order() {
      ++this.IsShow;
      if (this.IsShow == 6) {
        this.tlPaysearchs = [];
        this.getData();
      }
    },
    getInvoiceStatus(row) {
      const invoice = this.getInvoiceRecord(row);
      if (!invoice || invoice.status === undefined) {
        return "";
      }
      return String(invoice.status);
    },
    isInvoicePaymentSupported(row) {
      const paymentCode = String((row && row.payment_code) || "");
      return (
        paymentCode !== "balance" &&
        paymentCode !== "card_balance" &&
        paymentCode !== "family_balance" &&
        paymentCode !== "team_balance"
      );
    },
    canViewInvoice(row) {
      const status = this.getInvoiceStatus(row);
      return (
        this.invoiceButtonVisible &&
        row &&
        row.pay_status != 1 &&
        this.allOrder != 5 &&
        status !== "" &&
        status !== "0"
      );
    },
    canOpenInvoice(row) {
      const status = this.getInvoiceStatus(row);
      return (
        this.invoiceButtonVisible &&
        this.isInvoicePaymentSupported(row) &&
        row &&
        row.pay_status != 1 &&
        this.allOrder != 5 &&
        (status === "" || status === "0")
      );
    },
    parseInvoiceButtonStatus(res) {
      if (!res || res.code != 200) return true;
      const data = res.data;
      if (data === 0 || data === 1 || data === "0" || data === "1") {
        return Number(data) === 1;
      }
      if (data && (data.status === 0 || data.status === 1 || data.status === "0" || data.status === "1")) {
        return Number(data.status) === 1;
      }
      if (data && Array.isArray(data.value) && data.value.length) {
        const item = data.value.find(n => n.name === "invoice_button") || data.value[0];
        if (item && (item.status === 0 || item.status === 1 || item.status === "0" || item.status === "1")) {
          return Number(item.status) === 1;
        }
      }
      return true;
    },
    getInvoiceButtonConfig() {
      getConfigButtonStatus({
        token: this.token,
        app_id: this.app_id,
        button_name: "invoice_button"
      }).then(res => {
        this.invoiceButtonVisible = this.parseInvoiceButtonStatus(res);
      }).catch(() => {
        this.invoiceButtonVisible = true;
      });
    },
    getInvoiceRecord(row) {
      if (!row || !row.invoice) return null;
      return row.invoice.data || row.invoice.info || row.invoice;
    },
    getInvoiceFormFromInvoice(invoice = {}) {
      const form = createInvoiceForm();
      form.type_person = Number(
        invoice.type_person ||
          invoice.typePerson ||
          invoice.typePersonCode ||
          (invoice.taxNo || invoice.tax_no ? 2 : 1)
      );
      form.titleType = String(
        invoice.titleType || invoice.title_type || invoice.invoice_type || 1
      );
      form.buyerName =
        invoice.buyerName ||
        invoice.buyer_name ||
        invoice.title ||
        invoice.remark ||
        "";
      form.taxNo = invoice.taxNo || invoice.tax_no || "";
      form.companyAddress =
        invoice.companyAddress || invoice.company_address || "";
      form.companyTel =
        invoice.companyTel ||
        invoice.companyPhone ||
        invoice.company_phone ||
        invoice.phone ||
        "";
      form.bank = invoice.bank || invoice.bankName || invoice.bank_name || "";
      form.account =
        invoice.account || invoice.bankAccount || invoice.bank_account || "";
      form.email = invoice.email || invoice.buyerEmail || invoice.buyer_email || "";
      form.remark = invoice.remark || invoice.message || "";
      return form;
    },
    getInvoiceFormFromRow(row) {
      return this.getInvoiceFormFromInvoice(this.getInvoiceRecord(row) || {});
    },
    extractInvoiceDetailData(payload) {
      if (!payload || typeof payload !== "object") return null;
      const candidates = [
        payload.data,
        payload.info,
        payload.invoice,
        payload.detail,
        payload
      ];
      return (
        candidates.find(item => {
          if (!item || typeof item !== "object" || Array.isArray(item)) {
            return false;
          }
          return [
            "buyerName",
            "buyer_name",
            "title",
            "taxNo",
            "tax_no",
            "companyAddress",
            "company_address",
            "bank_account",
            "email",
            "buyer_email"
          ].some(key => item[key] !== undefined && item[key] !== "");
        }) || null
      );
    },
    async hydrateInvoiceFormFromDetail(row) {
      if (!row || !row.ordersn) return;
      try {
        const res = await get_invoice_detail({
          ordersn: row.ordersn,
          type: this.invoiceForm.type
        });
        if (res.code != 200 || !res.data) return;
        const detail = this.extractInvoiceDetailData(res.data);
        if (!detail) return;
        this.invoiceForm = {
          ...this.invoiceForm,
          ...this.getInvoiceFormFromInvoice(detail)
        };
        row.invoice = {
          ...(row.invoice || {}),
          ...detail
        };
      } catch (error) {
        console.log(error);
      }
    },
    getInvoiceTitleTypeLabel(val) {
      return String(val) === "2" ? "电子专用发票" : "电子普通发票";
    },
    getInvoicePersonTypeLabel(val) {
      return Number(val) === 2 ? "企业" : "个人";
    },
    formatInvoiceDisplay(val) {
      return val === 0 || val === "0" ? String(val) : val || "--";
    },
    applyInvoiceToRow(row, form, status) {
      if (!row) return;
      row.invoice = {
        ...(row.invoice || {}),
        status: status === undefined ? 1 : status,
        titleType: form.titleType,
        title_type: form.titleType,
        type_person: form.type_person,
        buyerName: form.buyerName,
        buyer_name: form.buyerName,
        taxNo: form.taxNo,
        tax_no: form.taxNo,
        companyAddress: form.companyAddress,
        company_address: form.companyAddress,
        companyTel: form.companyTel,
        company_phone: form.companyTel,
        bank: form.bank,
        bank_name: form.bank,
        account: form.account,
        bank_account: form.account,
        email: form.email,
        remark: form.remark
      };
    },
    show_invoic(row) {
      this.invoiceCurrentRow = row;
      this.invoiceForm = this.getInvoiceFormFromRow(row);
      this.invoiceReissueMode = false;
      this.checkInvoice = true;
      this.hydrateInvoiceFormFromDetail(row);
      if (!this.invoiceForm.buyerName && row.user && row.user.id) {
        getVipRemark({ uid: row.user.id }).then((res) => {
          if (res.code == 200 && res.data && res.data.remark) {
            this.invoiceForm.buyerName = res.data.remark;
          }
        });
      }
    },
    open_invoice(row) {
      this.invoiceCurrentRow = row;
      this.invoiceForm = this.getInvoiceFormFromRow(row);
      this.invoiceReissueMode = false;
      this.showInvoice = true;
      this.$nextTick(() => {
        this.$refs.invoiceFormRef && this.$refs.invoiceFormRef.clearValidate();
      });
    },
    closeInvoice() {
      this.showInvoice = false;
      this.invoiceReissueMode = false;
      this.invoiceSubmitLoading = false;
      if (this.invoiceSubmitTimer) {
        clearTimeout(this.invoiceSubmitTimer);
        this.invoiceSubmitTimer = null;
      }
      this.invoiceForm = createInvoiceForm();
      this.invoiceCurrentRow = null;
      this.$refs.invoiceFormRef && this.$refs.invoiceFormRef.resetFields();
    },
    closeCheckInvoice() {
      this.checkInvoice = false;
      this.invoiceReissueMode = false;
      this.invoiceSubmitLoading = false;
      if (this.invoiceSubmitTimer) {
        clearTimeout(this.invoiceSubmitTimer);
        this.invoiceSubmitTimer = null;
      }
      this.$refs.invoiceReissueFormRef &&
        this.$refs.invoiceReissueFormRef.resetFields();
      this.invoiceForm = createInvoiceForm();
      this.invoiceCurrentRow = null;
    },
    // 下载发票
    down_invoice() {
      get_invoice_detail({
        ordersn: this.invoiceCurrentRow.ordersn,
        type: this.invoiceForm.type
      }).then(res => {
        if (res.code == 200 && res.data.status == 'success') {
          window.open(res.data.download_url, "_blank");
        } else {
          this.$message.error(res.data.error_message || "下载发票失败");
        }
      })
    },
    onTitleTypeChange() {
      if (this.invoiceForm.type_person === 1) {
        this.invoiceForm.titleType = "1";
        this.invoiceForm.taxNo = "";
        this.invoiceForm.companyAddress = "";
        this.invoiceForm.companyTel = "";
        this.invoiceForm.bank = "";
        this.invoiceForm.account = "";
      }
    },
    confirmReissue() {
      if (this.invoiceCurrentRow) {
        this.invoiceForm = this.getInvoiceFormFromRow(this.invoiceCurrentRow);
        this.hydrateInvoiceFormFromDetail(this.invoiceCurrentRow).then(() => {
          this.invoiceReissueMode = true;
          this.$nextTick(() => {
            this.$refs.invoiceReissueFormRef &&
              this.$refs.invoiceReissueFormRef.clearValidate();
          });
        });
      }
    },
    submitInvoice(skipValidate = false) {
      if (!this.invoiceCurrentRow) {
        this.$message.error("未找到开票订单");
        return;
      }
      if (this.invoiceReissueMode && this.invoiceSubmitLoading) return;
      const submitHandler = () => {
        if (this.invoiceReissueMode) {
          this.invoiceSubmitLoading = true;
        } else {
          this.invoiceLoading = true;
        }
        const payload = {
          app_id: this.invoiceCurrentRow.app_id || this.app_id,
          ordersn: this.invoiceCurrentRow.ordersn,
          ...this.invoiceForm,
          type: this.allOrder === 2 ? 6 : 3,
          reissue: this.invoiceReissueMode ? 1 : 0
        };
        open_invoiceNo(payload).then((res) => {
          if (res.code == 200) {
            this.$message.success("发票申请已提交");
            this.applyInvoiceToRow(this.invoiceCurrentRow, this.invoiceForm, 1);
            if (
              this.invoiceForm.buyerName &&
              this.invoiceCurrentRow.user &&
              this.invoiceCurrentRow.user.id
            ) {
              setVipRemark({
                remark: this.invoiceForm.buyerName,
                uid: this.invoiceCurrentRow.user.id
              });
            }
            if (this.invoiceReissueMode) {
              if (this.invoiceSubmitTimer) {
                clearTimeout(this.invoiceSubmitTimer);
              }
              this.invoiceSubmitTimer = setTimeout(() => {
                this.invoiceSubmitTimer = null;
                this.invoiceSubmitLoading = false;
                this.closeCheckInvoice();
                this.getData(1);
              }, 2000);
              return;
            }
            this.closeInvoice();
          } else {
            this.$message.error(res.msg || "发票申请失败");
          }
        }).catch((error) => {
          this.$message.error("发票申请失败");
          console.log(error);
        }).finally(() => {
          if (!this.invoiceReissueMode) {
            this.invoiceLoading = false;
          } else if (!this.invoiceSubmitTimer) {
            this.invoiceSubmitLoading = false;
          }
        });
      };
      if (skipValidate) {
        submitHandler();
        return;
      }
      const formRef = this.invoiceReissueMode
        ? this.$refs.invoiceReissueFormRef
        : this.$refs.invoiceFormRef;
      formRef.validate((valid) => {
        if (!valid) return;
        submitHandler();
      });
    },
    //删除订单恢复
    recoverOrdered(status = "", id = "") {
      this.get_detail(); //是否需要验证码
      if (status == "1") {
        // 单个删除订单
        this.deleteForm.id = id;
        this.deleteForm.status = "1"; //单个删除
        if (!this.deleteForm.is_verification) {
          this.FakeOrder(2);
        }
      } else if (status == 2) {
        if (this.multipleSelection.length) {
          this.deleteForm.status = "2"; // 多选单个订单批量删除
          this.deleteForm.id = this.multipleSelection.join(",");
          if (!this.deleteForm.is_verification) {
            this.FakeOrder(2);
          }
        } else {
          this.$message("请选择订单记录");
          return;
        }
      } else {
        this.deleteForm.status = "3"; //时间范围的批量删除
      }
      if (this.deleteForm.is_verification || this.deleteForm.status == "3") {
        this.batchShows = true;
      }
    },
    //状态查询
    async Query_status(row) {
      if (this.allOrder == 2) {
        const res = await normal_order_Query({
          app_id: this.app_id,
          ordersn: row.ordersn,
        });
        if (res.code == 200) {
          console.log("状态查询1", res);
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } else {
        const res = await offline_order_query({
          app_id: this.app_id,
          ordersn: row.ordersn,
        });
        if (res.code == 200) {
          console.log("状态查询2", res);
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    //线上支付方式全选
    handleCheckAllChange(val) {
      console.log("全选", val);
      this.pay_typeArr = val ? ["wxpay", "alipay", "fuiou", "unionpay"] : [];
      this.isIndeterminates = false;
      this.getData(1);
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkALL = checkedCount == this.pay_type.length;
      this.isIndeterminates =
        checkedCount > 0 && checkedCount < this.pay_type.length;
      this.getData(1);
    },
    // 安全設置详情
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          this.config = res.data;
          this.deleteForm.is_verification = res.data.open_sms_delete_order != 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    closeBatchPopup() {
      this.batchShows = false;
      this.batchShow = false;
      this.dateValueFake = [];
      this.timeValueFake = [];
      this.deleteForm = {
        status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
        id: "",
        code: "", //验证码
        is_verification: this.deleteForm.is_verification,
      };
    },
    init() {
      //初始化数据
      this.loading = true;
      if (sessionStorage.getItem("dateCache")) {
        this.dateValue = sessionStorage.getItem("dateCache").split(",");
      }
      if (sessionStorage.getItem("timeCache")) {
        this.timeValue = sessionStorage.getItem("timeCache").split(",");
      }

      get_search_biz_user_id({ app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.tlPaysearchs = res.data.biz_user_ids;
        }
      });
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      storeSelect(data).then((res) => {
        if (res.code == 200) {
          this.store_options = res.data;
          this.loading = false;
        } else {
        }
      });
      vipList({ ...data, limit: 9999 }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            this.level_options.push({ id: item.id, name: item.name });
          });
        } else {
        }
      });
      employeeOptions(data).then((res) => {
        if (res.code == 200) {
          let obj = {};
          obj.id = "0";
          obj.name = "买单";
          this.emp_options = res.data;
          this.emp_options.push(obj);
        } else {
        }
      });
      equipmentOptions(data).then((res) => {
        if (res.code == 200) {
          this.equ_options = res.data;
        } else {
        }
      });
      goodsOptions(data).then((res) => {
        if (res.code == 200) {
          this.oils_options = [{ id: "0", name: "全部" }];
          res.data.forEach((item) => {
            this.oils_options.push({ id: String(item.id), name: item.name });
          });
        } else {
        }
      });
    },
    //获取表格数据
    getData(i) {
      if (i == 1) {
        this.searchNumber = false;
        this.page = 1;
      }
      this.tableLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        biz_user_ids: this.tlPaysearchs.join(","),
        user_level_id: this.params.user_level_id,
      };
      if (this.discount_list.length > 0) {
        for (let i = 0; i < this.discount_list.length; i++) {
          let keys = this.discount_list[i];
          data[keys] = 1;
        }
      }

      if (this.refreshData) {
        data.refresh = "1";
      }
      if (this.goods_id != "0") {
        data.goods_id = this.goods_id;
      }
      if (this.params.ordersn != "") {
        data.ordersn = this.params.ordersn;
      }
      if (this.params.mobile != "") {
        data.mobile = this.params.mobile;
      }
      if (this.params.amount_start != "" && this.params.amount_end != "") {
        data.amount_start = this.params.amount_start;
        data.amount_end = this.params.amount_end;
      }
      if (this.params.room_id != "") {
        data.room_id = this.params.room_id;
      }
      if (this.params.emp_id != "") {
        data.emp_id = this.params.emp_id;
      }
      if (this.params.cate_id != "") {
        data.cate_id = this.params.cate_id;
      }
      if (this.params.source != "") {
        data.source = this.params.source;
      }
      if (this.params.payment_code != "0") {
        if (this.params.payment_code == "pos") {
          data.pay_source = "pos";
        } else if (this.params.payment_code == "xs") {
          data.payment_code = this.pay_typeArr.join(",");
        } else {
          data.payment_code = this.params.payment_code;
        }
      }
      if (this.params.time != "0") {
        if (this.params.time == "1") {
          data.pay_start_time = this.formatTime(new Date(), 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "2") {
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(start, 2);
        }
        if (this.params.time == "7") {
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "30") {
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "m") {
          data.pay_start_time = this.formatTime(new Date(), 3);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "y") {
          data.pay_start_time = this.formatTime(new Date(), 4);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "z") {
          if (this.dateValue !== null && this.dateValue.length !== 0) {
            data.pay_start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            data.pay_end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
          }
        }
        // 未支付状态参数传创建时间create_time_s/create_time_e 已支付传pay_start_time/pay_end_time
        if (this.params.pay_status == "1") {
          data.create_time_s = data.pay_start_time;
          data.create_time_e = data.pay_end_time;
          delete data.pay_start_time;
          delete data.pay_end_time;
        }
      }
      if (this.params.pay_status != "0") {
        data.pay_status = this.params.pay_status;
      }
      console.log("uid?????????????", this.uid);
      if (this.uid != "") {
        data.uid = this.uid;
        this.showTableItems[1].show = false;
        this.showTableItems[2].show = false;
        this.showTableItems[3].show = false;
      }
      for (var item in data) {
        console.log("data." + item + "=" + data[item]);
      }
      if (this.searchNumber) {
        data = {
          token: this.token,
          app_id: this.app_id,
          number: this.params.number,
          page: this.page,
        };
      }
      if (this.allOrder == 0) {
        //总订单
        oilsOrder(data).then((res) => {
          console.log("zong", res);
          this.tableLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status =
                item.pay_status == "1"
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已支付"
                  : item.pay_status == 4
                  ? "已退款"
                  : "冻结";
              if (item.payment_code == "wxpay") {
                item.show_payway = "微信支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else if (item.payment_code == "alipay") {
                item.show_payway = "支付宝支付";
              } else if (item.payment_code == "fuiou") {
                item.show_payway = "闪付";
              } else if (item.payment_code == "pos") {
                item.show_payway = "刷卡";
              } else {
                item.show_payway = "";
              }
              // item.show_payway = item.payment_code == 'wxpay'? "微信支付":item.payment_code == 'balance'? "余额支付":item.payment_code == 'cash'? "现金":""
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              console.log("laiyuan", item.source);
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.length == 0 && this.uid == "") {
              this.$message(res.msg);
            }
            this.total = res.total;
            if (this.refreshData || res.count) {
              console.log("count", Object.assign({}, res.count));
              this.statData = Object.assign({}, res.count);
              console.log("yilian", res);
              this.statData.unionpay = res.count.pay_type.find(
                (x) => x.payment_code == "unionpay"
              ).total_amount;
              // this.statData.wxpay = res.count.pay_type.find(x => x.payment_code == 'wxpay').total_amount
              this.statData.cash = res.count.pay_type.find(
                (x) => x.payment_code == "cash"
              ).total_amount;
              this.statData.balance = res.count.pay_type.find(
                (x) => x.payment_code == "balance"
              ).total_amount;
              this.statData.card_balance = res.count.pay_type.find(
                (x) => x.payment_code == "card_balance"
              ).total_amount;
              this.statData.family_balance = res.count.pay_type.find(
                (x) => x.payment_code == "family_balance"
              ).total_amount;
              this.statData.team_balance = res.count.pay_type.find(
                (x) => x.payment_code == "team_balance"
              ).total_amount;
              this.receiptNum = res.count.receipt;
              this.cashTotal = res.count.waitcash;
              this.refreshData = false;
            }
          } else {
            if (res.code == 400) {
              this.tableData = [];
              this.total = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      } else if (this.allOrder == 2) {
        vipOrdinaryList(data).then((res) => {
          console.log("333333", res);
          this.tableLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.data;
            this.tableData.forEach((item) => {
              // item.show_catename = item.cate ? item.cate.name : "";
              // item.show_goodsname = item.goods
              //   ? item.cate.name + " " + item.goods.name + item.type.name
              //   : "";
              if (item.uid <= 0) {
                item.user = {
                  mobile: "",
                };
              }
              item.show_payTime = item.payment_time;

              item.show_status =
                item.pay_status == "1"
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已支付"
                  : item.pay_status == 4
                  ? "已退款"
                  : "冻结";
              if (item.payment_code == "wxpay") {
                item.show_payway = "微信支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else if (item.payment_code == "alipay") {
                item.show_payway = "支付宝支付";
              } else if (item.payment_code == "fuiou") {
                item.show_payway = "闪付";
              } else if (item.payment_code == "pos") {
                item.show_payway = "刷卡";
              } else {
                item.show_payway = "";
              }
              // item.show_payway = item.payment_code == 'wxpay'? "微信支付":item.payment_code == 'balance'? "余额支付":item.payment_code == 'cash'? "现金":""
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.data.length == 0 && this.uid == "") {
              this.$message("没有更多了");
            }
            this.total = res.data.total;

            if (this.refreshData || res.count) {
              // let total_fee = 0;
              console.log("count", Object.assign({}, res.data.count));
              this.statData = Object.assign({}, res.data.count);
              console.log(this.statData);
              // res.data.data.forEach((item) => {
              //   item.fee += total_fee;
              // });
              // this.statData.total_fee = total_fee;
              this.statData.total_order = res.data.total;
            }
          } else {
            if (res.code == 400) {
              this.tableData = [];
              this.total = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      } else if (this.allOrder == 3) {
        //上一班次订单
        delete data.pay_end_time;
        delete data.pay_start_time;
        last_shift_lists(data).then((res) => {
          this.tableLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status =
                item.pay_status == "1"
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已支付"
                  : item.pay_status == 4
                  ? "已退款"
                  : "冻结";
              if (item.payment_code == "wxpay") {
                item.show_payway = "微信支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else if (item.payment_code == "alipay") {
                item.show_payway = "支付宝支付";
              } else if (item.payment_code == "fuiou") {
                item.show_payway = "闪付";
              } else if (item.payment_code == "pos") {
                item.show_payway = "刷卡";
              } else {
                item.show_payway = "";
              }
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.length == 0 && this.uid == "") {
              this.$message("没有更多了");
            }
            this.total = res.total;
            if (this.refreshData || res.count) {
              this.statData = Object.assign({}, res.count);
              this.statData.unionpay = res.count.pay_type.find(
                (x) => x.payment_code == "unionpay"
              ).total_amount;
              // this.statData.wxpay = res.count.pay_type.find(x => x.payment_code == 'wxpay').total_amount
              this.statData.cash = res.count.pay_type.find(
                (x) => x.payment_code == "cash"
              ).total_amount;
              this.statData.balance = res.count.pay_type.find(
                (x) => x.payment_code == "balance"
              ).total_amount;
              this.statData.card_balance = res.count.pay_type.find(
                (x) => x.payment_code == "card_balance"
              ).total_amount;
              this.statData.family_balance = res.count.pay_type.find(
                (x) => x.payment_code == "family_balance"
              ).total_amount;
              this.statData.team_balance = res.count.pay_type.find(
                (x) => x.payment_code == "team_balance"
              ).total_amount;
              this.receiptNum = res.count.receipt;
              this.cashTotal = res.count.waitcash;
              this.refreshData = false;
            }
          } else {
            if (res.code == 400) {
              this.tableData = [];
              this.total = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      } else if (this.allOrder == 5) {
        //删除订单

        deleteOrderList(data).then((res) => {
          this.tableLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status =
                item.pay_status == "1"
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已支付"
                  : item.pay_status == 4
                  ? "已退款"
                  : "冻结";
              if (item.payment_code == "wxpay") {
                item.show_payway = "微信支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else if (item.payment_code == "alipay") {
                item.show_payway = "支付宝支付";
              } else if (item.payment_code == "fuiou") {
                item.show_payway = "闪付";
              } else if (item.payment_code == "pos") {
                item.show_payway = "刷卡";
              } else {
                item.show_payway = "";
              }
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.length == 0 && this.uid == "") {
              this.$message("没有更多了");
            }
            this.total = res.total;
            if (this.refreshData || res.count) {
              this.statData = Object.assign({}, res.count);
              this.statData.unionpay = res.count.pay_type.find(
                (x) => x.payment_code == "unionpay"
              ).total_amount;
              // this.statData.wxpay = res.count.pay_type.find(x => x.payment_code == 'wxpay').total_amount
              this.statData.cash = res.count.pay_type.find(
                (x) => x.payment_code == "cash"
              ).total_amount;
              this.statData.balance = res.count.pay_type.find(
                (x) => x.payment_code == "balance"
              ).total_amount;
              this.statData.card_balance = res.count.pay_type.find(
                (x) => x.payment_code == "card_balance"
              ).total_amount;
              this.statData.family_balance = res.count.pay_type.find(
                (x) => x.payment_code == "family_balance"
              ).total_amount;
              this.statData.team_balance = res.count.pay_type.find(
                (x) => x.payment_code == "team_balance"
              ).total_amount;
              this.receiptNum = res.count.receipt;
              this.cashTotal = res.count.waitcash;
              this.refreshData = false;
            }
          } else {
            if (res.code == 400) {
              this.tableData = [];
              this.total = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      } else {
        //当前班次订单
        delete data.pay_end_time;
        delete data.pay_start_time;
        vipOrderListNow(data).then((res) => {
          this.tableLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status =
                item.pay_status == "1"
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已支付"
                  : item.pay_status == 4
                  ? "已退款"
                  : "冻结";
              if (item.payment_code == "wxpay") {
                item.show_payway = "微信支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else if (item.payment_code == "alipay") {
                item.show_payway = "支付宝支付";
              } else if (item.payment_code == "fuiou") {
                item.show_payway = "闪付";
              } else if (item.payment_code == "pos") {
                item.show_payway = "刷卡";
              } else {
                item.show_payway = "";
              }
              // item.show_payway = item.payment_code == 'wxpay'? "微信支付":item.payment_code == 'balance'? "余额支付":item.payment_code == 'cash'? "现金":""
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.length == 0 && this.uid == "") {
              this.$message("没有更多了");
            }
            this.total = res.total;
            if (this.refreshData || res.count) {
              this.statData = Object.assign({}, res.count);
              this.statData.unionpay = res.count.pay_type.find(
                (x) => x.payment_code == "unionpay"
              ).total_amount;
              // this.statData.wxpay = res.count.pay_type.find(x => x.payment_code == 'wxpay').total_amount
              this.statData.cash = res.count.pay_type.find(
                (x) => x.payment_code == "cash"
              ).total_amount;
              this.statData.balance = res.count.pay_type.find(
                (x) => x.payment_code == "balance"
              ).total_amount;
              this.statData.card_balance = res.count.pay_type.find(
                (x) => x.payment_code == "card_balance"
              ).total_amount;
              this.statData.family_balance = res.count.pay_type.find(
                (x) => x.payment_code == "family_balance"
              ).total_amount;
              this.statData.team_balance = res.count.pay_type.find(
                (x) => x.payment_code == "team_balance"
              ).total_amount;
              this.receiptNum = res.count.receipt;
              this.cashTotal = res.count.waitcash;
              this.refreshData = false;
            }
          } else {
            if (res.code == 400) {
              this.tableData = [];
              this.total = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      }
    },
    searchNum() {
      this.searchNumber = true;
      this.page = 1;
      this.getData();
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach((item) => {
        this.multipleSelection.push(item.id);
      });
      console.log(this.multipleSelection);
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    // 选择顶部标签页
    handleClick(val) {
      console.log(val.name);
      this.goods_id = val.name;
      this.page = 1;
      this.getData();
    },
    search() {
      this.page = 1;
      this.getData();
    },
    // 清空
    clearAll() {
      this.page = 1;
      this.dateValue = [];
      this.params = {
        card_num: "", //会员卡号
        ordersn: "", //订单编号
        user_level_id: "", //等级id
        room_id: "", //门店id
        emp_id: "", //员工id
        cate_id: "", //油枪id
      };
      this.getData();
    },
    //获取异常订单
    errorOrder() {
      var _this = this;
      this.showErrorOrder = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.errorPage,
      };
      if (this.errorParams.status != "") {
        data.status = this.errorParams.status;
      }
      if (this.errorParams.payment_code != "") {
        data.payment_code = this.errorParams.payment_code;
      }
      if (
        this.errorParams.timeValue !== null &&
        this.errorParams.timeValue.length !== 0
      ) {
        data.pay_start_time = this.errorParams.timeValue[0];
        data.pay_end_time = this.errorParams.timeValue[1];
      }
      oilsErrorOrder(data).then((res) => {
        if (res.code == 200) {
          this.errorOrderList = res.data;
          this.errorOrderList.forEach((item) => {
            item.show_status = item.status == "1" ? "已处理" : "未处理";
            item.show_time = _this.formatDate(Number(item.pay_time) * 1000);
            if (item.payment_code == "wxpay") {
              item.show_payway = "微信支付";
            } else if (item.payment_code == "balance") {
              item.show_payway = "余额支付";
            } else if (item.payment_code == "cash") {
              item.show_payway = "现金支付";
            } else if (item.payment_code == "single_wxpay") {
              item.show_payway = "微信免签";
            } else if (item.payment_code == "single_alipay") {
              item.show_payway = "支付宝免签";
            } else if (item.payment_code == "unionpay") {
              item.show_payway = "银联支付";
            } else if (item.payment_code == "card_balance") {
              item.show_payway = "加油卡支付";
            } else if (item.payment_code == "allinpay") {
              item.show_payway = "通联支付";
            } else if (item.payment_code == "normal_allinpay") {
              item.show_payway = "聚合支付";
            } else if (item.payment_code == "lakala") {
              item.show_payway = "快捷支付";
            } else if (item.payment_code == "leshua") {
              item.show_payway = "乐 付";
            } else {
              item.show_payway = "";
            }
          });
        } else if (res.code == 400) {
          this.errorOrderList = [];
          this.$message(res.msg);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 查询订单号
    searchOrdersn() {
      this.page = 1;
      this.tableData = [];
      this.getData(1);
    },
    // 异常订单跳页
    handleCurrentChangeError(p) {
      this.errorPage = p;
      this.errorOrder();
    },
    // 清空异常订单筛选
    clearErrorParams() {
      this.errorPage = 1;
      this.errorParams = {
        status: "", //状态
        timeValue: [], //时间
        payment_code: "", //支付方式
        pay_money: "", //金额
        opt: ">", //金额
      };
      this.errorOrder();
    },
    // 修改异常订单状态
    changeErrorStatus(i) {
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: this.multipleSelection.join(","),
        status: i == 1 ? "1" : "0",
      };
      errorOrderStatus(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功！",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.errorOrder();
      });
    },
    // 删除异常订单
    delErrorOrder() {
      this.$confirm("删除后无法恢复，确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: this.multipleSelection.join(","),
          };
          errorOrderDel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功！",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
            this.errorOrder();
          });
        })
        .catch();
    },
    // 格式化时间戳
    formatDate(t) {
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      mm = mm < 10 ? "0" + mm : mm;
      return y + "-" + m + "-" + d + " " + h + ":" + mm;
    },
    formatTime(t, i) {
      //t:时间 i:格式化 1.截取到日期的00:00:00 2.截取到日期的23:59:59 3.截取到本月开始时间 4.截取到本年开始时间
      var time = this.formatDate(t);
      if (i == 1) {
        var rt = time.split(" ")[0] + " 00:00:00";
        return rt;
      } else if (i == 2) {
        var rt = time.split(" ")[0] + " 23:59:59";
        return rt;
      } else if (i == 3) {
        var rt = time.split("-")[0] + "-" + time.split("-")[1] + "-01 00:00:00";
        return rt;
      } else if (i == 4) {
        var rt = time.split("-")[0] + "-01-01 00:00:00";
        return rt;
      }
    },
    changeTime(val) {
      console.log(val);
      if (val != "z") {
        this.getData(1);
      }
    },
    // 时间筛选
    timeSearch(key) {
      if (key == "search") {
        if (!this.dateValue[0]) {
          this.$message("未选择开始时间");
        } else if (!this.dateValue[1]) {
          this.$message("未选择结束时间");
        } else if (
          new Date(this.dateValue[0]).getTime() >
          new Date(this.dateValue[1]).getTime()
        ) {
          this.$message("开始时间不能大于结束时间");
        } else {
          this.getData(1);
        }
      }
      console.log(key);
      if (key == "export") {
        let a = new Date(this.dateValue[0]).getTime();
        let b = new Date(this.dateValue[1]).getTime();
        let c = b - a;
        console.log(Math.floor(c / 86400000));
        if (!this.dateValue[0]) {
          // this.$message("未选择开始时间");
          return {
            val: false,
            msg: "未选择开始时间",
          };
        } else if (!this.dateValue[1]) {
          // this.$message("未选择结束时间");
          return {
            val: false,
            msg: "未选择结束时间",
          };
        } else if (
          new Date(this.dateValue[0]).getTime() >
          new Date(this.dateValue[1]).getTime()
        ) {
          // this.$message("开始时间不能大于结束时间");
          return {
            val: false,
            msg: "开始时间不能大于结束时间",
          };
        } else if (Math.floor(c / 86400000) > 31) {
          // this.$message("开始时间与结束时间,间隔不能超过一个月");
          return {
            val: false,
            msg: "开始时间与结束时间,间隔不能超过一个月",
          };
          // return true
        } else {
          return {
            val: true,
            msg: "",
          };
        }
      }
    },
    // 确认未支付订单窗口
    confirmOrderItem(ordersn, type, pay_type) {
      if (pay_type == "cash") {
        this.handlePay[0] = {
          label: "现金",
          value: "cash",
        };
      } else if (pay_type == "unionpay") {
        this.handlePay[0] = {
          label: "银联pos支付",
          value: "unionpay",
        };
      }
      this.confirmData = {
        ordersn: ordersn,
        type: pay_type,
      };
      if (type == 1) {
        this.showConfirmOrder = true;
      } else {
        this.showCancelOrder = true;
      }
    },
    // 确认未支付订单
    confirmOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
        payment_code: this.confirmData.type,
      };
      this.submitLoading = true;
      confirmOrder(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.showConfirmOrder = false;
          this.refreshData = true;
          this.getData();
          this.getCashData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.submitLoading = false;
      });
    },
    // 取消未支付订单
    cancelOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
      };
      this.submitLoading = true;
      cancelOrder(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
          this.showCancelOrder = false;
          this.getData();
          this.getCashData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.submitLoading = false;
      });
    },
    // 收款详情
    MoneyDetail(data) {
      this.moneyDetailMsg = {
        money: data.money,
        dec_discount_money: data.dec_discount_money,
        dec_coupon_money: data.dec_coupon_money,
        dec_point_money: data.dec_point_money,
        pay_discount: data.pay_discount,
        amount: data.amount,
        platform_discount: data.platform_discount,
        bonus_dec_money: data.bonus_dec_money,
      };
      let numValue =
        Number(data.money) -
        Number(data.dec_discount_money) -
        Number(data.dec_coupon_money) -
        Number(data.pay_discount) -
        Number(data.dec_point_money) -
        Number(data.amount);
      console.log("优惠金额", numValue);
      if (data.payment_code != "cash") {
        this.moneyDetailMsg.is_rounding = false;
      } else {
        this.moneyDetailMsg.is_rounding = true;
      }
      // if (numValue == 0) {
      //   this.moneyDetailMsg.is_rounding = false;
      // } else if (numValue > 0) {
      //   this.moneyDetailMsg.roundTitle = "现金多收凑整";
      // } else if (numValue < 0) {
      //   this.moneyDetailMsg.roundTitle = "现金优惠凑整：";
      // }
      if (data.payment_code != "cash") {
        this.moneyDetailMsg.is_rounding = false;
      } else {
        this.moneyDetailMsg.is_rounding = true;
      }
      this.moneyDetailMsg.numValue = numValue.toFixed(2);
      this.showMoneyDetail = true;
    },
    // 点击行跳转用户详情
    rowClick(id) {
      console.log("hang");
      this.$router.push({
        path: "/apply/newVip/13/center/userDetail",
        query: { id: id },
      });
    },
    // 导出方法
    exportList() {
      if (this.params.time == "z") {
        var obj = this.timeSearch("export");
        console.log(obj.val);
        if (obj.val) {
          let api = "offlinestore/agent.order/index";
          if (this.allOrder == 2) {
            api = "manage/order.normal_order/index";
          } else if (this.allOrder == 3) {
            api = "offlinestore/agent.Order/last_shift_lists";
          } else {
            api = "offlinestore/agent.order/index";
          }
          var data = {
            token: this.token,
            Api: api,
            params: [{ name: "app_id", value: this.app_id }],
          };
          if (this.goods_id != "0") {
            data.params.push({
              name: "goods_id",
              value: this.goods_id,
            });
          }
          if (this.params.ordersn) {
            data.params.push({
              name: "ordersn",
              value: this.params.ordersn,
            });
          }
          if (this.params.room_id) {
            data.params.push({
              name: "room_id",
              value: this.params.room_id,
            });
          }
          if (this.params.emp_id) {
            data.params.push({
              name: "emp_id",
              value: this.params.emp_id,
            });
          }
          if (this.params.cate_id) {
            data.params.push({
              name: "cate_id",
              value: this.params.cate_id,
            });
          }
          if (this.params.payment_code != "0") {
            data.params.push({
              name: "payment_code",
              value: this.params.payment_code,
            });
          }
          if (this.params.time != "0") {
            if (this.params.time == "1") {
              data.pay_start_time = this.formatTime(new Date(), 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "2") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(start, 2);
            }
            if (this.params.time == "7") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "30") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "m") {
              data.pay_start_time = this.formatTime(new Date(), 3);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "y") {
              data.pay_start_time = this.formatTime(new Date(), 4);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "z") {
              if (this.dateValue !== null && this.dateValue.length !== 0) {
                data.pay_start_time = this.timeValue[0]
                  ? this.dateValue[0] + " " + this.timeValue[0]
                  : this.dateValue[0] + " 00:00:00";
                data.pay_end_time = this.timeValue[1]
                  ? this.dateValue[1] + " " + this.timeValue[1]
                  : this.dateValue[1] + " 23:59:59";
              }
            }
            // 未支付状态参数传创建时间create_time_s/create_time_e 已支付传pay_start_time/pay_end_time
            if (this.params.pay_status == "1") {
              data.create_time_s = data.pay_start_time;
              data.create_time_e = data.pay_end_time;
              delete data.pay_start_time;
              delete data.pay_end_time;
              data.params.push({
                name: "create_time_s",
                value: data.create_time_s,
              });
              data.params.push({
                name: "create_time_e",
                value: data.create_time_e,
              });
            } else {
              data.params.push({
                name: "pay_start_time",
                value: data.pay_start_time,
              });
              data.params.push({
                name: "pay_end_time",
                value: data.pay_end_time,
              });
            }
          }
          if (this.params.pay_status != "0") {
            data.params.push({
              name: "pay_status",
              value: this.params.pay_status,
            });
          }
          if (this.params.mobile) {
            data.params.push({
              name: "mobile",
              value: this.params.mobile,
            });
          }
          if (this.params.amount_start && this.params.amount_end) {
            data.params.push(
              {
                name: "amount_start",
                value: this.params.amount_start,
              },
              {
                name: "amount_end",
                value: this.params.amount_end,
              }
            );
          }
          console.log(data);
          exportMethod(data);
        } else {
          this.$message.error(obj.msg);
        }
      } else {
        this.$message("请选择自定义时间导出");
      }
    },
    // 打印小票
    printReceipt(id) {
      this.$confirm("确定打印该订单的小票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.allOrder == 2) {
            print_normal_order({ id: id, app_id: this.app_id }).then((res) => {
              if (res.code == 200) {
                this.$message.success(res.msg);
              } else {
                this.$message(res.msg);
              }
            });
          } else {
            orderPrint({ id: id, app_id: this.app_id }).then((res) => {
              if (res.responseCode == 0) {
                this.$message.success(res.msg);
              } else {
                this.$message(res.msg);
              }
            });
          }
        })
        .catch(() => {});
    },
    // 批量删除
    batchDetele(status = "", id = "") {
      this.get_detail(); //是否需要验证码
      if (status == "1") {
        // 单个删除订单
        this.deleteForm.id = id;
        this.deleteForm.status = "1"; //单个删除
        if (!this.deleteForm.is_verification) {
          this.FakeOrder(1);
        }
      } else if (status == 2) {
        if (this.multipleSelection.length) {
          this.deleteForm.status = "2"; // 多选单个订单批量删除
          this.deleteForm.id = this.multipleSelection.join(",");
          if (!this.deleteForm.is_verification) {
            this.FakeOrder(1);
          }
        } else {
          this.$message("请选择订单记录");
          return;
        }
      } else {
        this.deleteForm.status = "3"; //时间范围的批量删除
      }
      if (this.deleteForm.is_verification || this.deleteForm.status == "3") {
        this.batchShow = true;
      }
    },
    // 假删除订单
    FakeOrder(key) {
      if (this.deleteForm.is_verification) {
        if (this.deleteForm.code == "") {
          this.$message.warning("请填写正确的验证码！！");
          return;
        }
      }
      if (this.deleteForm.status == "3") {
        if (
          this.dateValueFake.length !== 2 &&
          this.timeValueFake.length !== 2
        ) {
          this.$message.warning("请正确填写时间范围！！");
          return;
        }
        var startD = new Date(
          Date.parse(this.dateValueFake[0].replace(/-/g, "/"))
        );
        var endD = new Date(
          Date.parse(this.timeValueFake[0].replace(/-/g, "/"))
        );
        var days = parseInt(
          (endD.getTime() - startD.getTime()) / (1000 * 60 * 60 * 24)
        );
        if (days > 30) {
          this.$message.warning("日期范围应在一个月之内！！");
          return false;
        }
      }
      if (key == 2) {
        let data = {
          app_id: this.app_id,
          verification_code: this.deleteForm.code,
        };
        if (this.deleteForm.status != 3) {
          data.id = this.deleteForm.id;
        }
        if (this.deleteForm.status == 3) {
          // data.create_time_s
          data.create_time_s = this.dateValueFake.join(" ");
          data.create_time_e = this.timeValueFake.join(" ");
        }
        recoverOrder(data).then((res) => {
          if (res.code == 200) {
            this.batchShows = false;
            this.dateValueFake = [];
            this.timeValueFake = [];
            this.deleteForm = {
              status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
              id: "",
              code: "", //验证码
              is_verification: false,
            };
            this.getData();
            this.$message.success("恢复成功");
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        this.$confirm("确定要删除这些订单吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let data = {
              app_id: this.app_id,
              verification_code: this.deleteForm.code,
            };
            if (this.deleteForm.status != 3) {
              data.id = this.deleteForm.id;
            }
            if (this.deleteForm.status == 3) {
              // data.create_time_s
              data.create_time_s = this.dateValueFake.join(" ");
              data.create_time_e = this.timeValueFake.join(" ");
            }
            if (this.allOrder == 2) {
              deleteOrder_pt(data).then((res) => {
                if (res.code == 200) {
                  this.batchShow = false;
                  this.dateValueFake = [];
                  this.timeValueFake = [];
                  this.deleteForm = {
                    status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
                    id: "",
                    code: "", //验证码
                    is_verification: false,
                  };
                  this.getData();
                  this.$message.success(res.msg);
                } else {
                  this.$message(res.msg);
                }
              });
            } else {
              deleteFakeOrder(data).then((res) => {
                if (res.code == 200) {
                  this.batchShow = false;
                  this.dateValueFake = [];
                  this.timeValueFake = [];
                  this.deleteForm = {
                    status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
                    id: "",
                    code: "", //验证码
                    is_verification: false,
                  };
                  this.getData();
                  this.$message.success(res.msg);
                } else {
                  this.$message(res.msg);
                }
              });
            }
          })
          .catch(() => {});
      }
    },
    // 查询现金待支付订单
    cashConfirmOrder() {
      this.showCashConfirm = true;
      this.getCashData();
    },
    getCashData() {
      this.cashLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.cashPage,
        pay_status: "1",
        payment_code: "cash",
      };
      if (this.mobile !== "") {
        data.mobile = this.mobile;
      }
      if (this.allOrder == 0) {
        //总订单
        oilsOrder(data).then((res) => {
          this.cashLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.cashConfirmData = res.data;

            this.cashConfirmData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status = item.pay_status == "1" ? "未支付" : "已支付";
              if (item.payment_code == "wxpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else {
                item.show_payway = "";
              }
              // item.show_payway = item.payment_code == 'wxpay'? "微信支付":item.payment_code == 'balance'? "余额支付":item.payment_code == 'cash'? "现金":""
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            this.cashTotal = res.total;
          } else {
            if (res.code == 400) {
              this.cashConfirmData = [];
              this.cashTotal = 0;
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      } else {
        //当前班次订单
        vipOrderListNow(data).then((res) => {
          this.cashLoading = false;
          if (res.code == 200 || res.code == 400) {
            this.cashConfirmData = res.data;
            this.cashConfirmData.forEach((item) => {
              item.show_catename = item.cate ? item.cate.name : "";
              item.show_goodsname = item.goods
                ? item.cate.name + " " + item.goods.name + item.type.name
                : "";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_status = item.pay_status == "1" ? "未支付" : "已支付";
              if (item.payment_code == "wxpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "balance") {
                item.show_payway = "余额支付";
              } else if (item.payment_code == "cash") {
                item.show_payway = "现金支付";
              } else if (item.payment_code == "single_wxpay") {
                item.show_payway = "微信免签";
              } else if (item.payment_code == "single_alipay") {
                item.show_payway = "支付宝免签";
              } else if (item.payment_code == "unionpay") {
                item.show_payway = "银联支付";
              } else if (item.payment_code == "card_balance") {
                item.show_payway = "加油卡支付";
              } else if (item.payment_code == "allinpay") {
                item.show_payway = "通联支付";
              } else if (item.payment_code == "normal_allinpay") {
                item.show_payway = "聚合支付";
              } else if (item.payment_code == "lakala") {
                item.show_payway = "快捷支付";
              } else if (item.payment_code == "leshua") {
                item.show_payway = "乐 付";
              } else if (item.payment_code == "family_balance") {
                item.show_payway = "亲属卡支付";
              } else if (item.payment_code == "team_balance") {
                item.show_payway = "车队卡支付";
              } else {
                item.show_payway = "";
              }
              // item.show_payway = item.payment_code == 'wxpay'? "微信支付":item.payment_code == 'balance'? "余额支付":item.payment_code == 'cash'? "现金":""
              item.show_empname = item.emp == null ? "买单" : item.emp.name;
              item.show_from = this.from_options.find(
                (x) => x.id == item.source
              ).name;
            });
            if (res.data.length == 0 && this.uid == "") {
              this.$message("没有更多了");
            }
            this.cashTotal = res.total;
            console.log(this.cashTotal);
          } else {
            if (res.code == 400) {
              this.cashConfirmData = [];
              this.cashTotal = 0;
              if (this.uid == "") {
                this.$message("没有更多了");
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          }
        });
      }
    },
    closeCashConfirm() {
      this.showCashConfirm = false;
      this.cashConfirmData = [];
      this.cashPage = 1;
      // this.cashTotal = 0;
    },
    showReceiptOrder() {
      this.showReceipt = true;

      this.tableData.forEach((item, i) => {
        console.log(item.receipt);
      });
    },
    cacheTime(i) {
      if (i == 1) {
        var dateCache = this.dateValue.join(",");
        sessionStorage.setItem("dateCache", dateCache);
      } else {
        var timeCache = this.timeValue.join(",");
        sessionStorage.setItem("timeCache", timeCache);
      }
    },
    // cacheTimeFake(i){
    //   if(i == 1){
    //     var dateCache = this.dateValue.join(',')
    //     sessionStorage.setItem('dateCache',dateCache);
    //   }else{
    //     var timeCache = this.timeValue.join(',');
    //     sessionStorage.setItem('timeCache',timeCache);
    //   }
    // },
    // 刷新
    refresh() {
      this.refreshData = true;
      this.getData();
    },
    // 作废已支付的现金订单
    // delCashOrder(ordersn) {
    // 	this.$confirm("作废订单无法恢复，确定?", "提示", {
    // 		confirmButtonText: "确定",
    // 		cancelButtonText: "取消",
    // 	})
    // 		.then(() => {
    // 			var data = {
    // 				token: this.token,
    // 				app_id: this.app_id,
    // 				ordersn: ordersn,
    // 			};
    // 			cancalCashOrder(data).then((res) => {
    // 				if (res.code == 200) {
    // 					this.$message({
    // 						type: "success",
    // 						message: "作废成功！",
    // 					});
    // 					this.refresh();
    // 					this.$refs.cancalCashOrder.getData();
    // 				} else {
    // 					this.$message({
    // 						type: "error",
    // 						message: res.msg,
    // 					});
    // 				}
    // 			});
    // 		})
    // 		.catch();
    // },
    // 订单退款
    refundShow(row) {
      this.refund.ordersn = row.ordersn;
      this.refund.money = row.amount;
      this.refund.name = row.name;
      this.refundIsShow = true;
    },
    closeRefund() {
      this.refund.ordersn = "";
      this.refund.money = "";
      this.refund.name = "";
      this.refundIsShow = false;
      this.refund.desc = "";
      this.refund.verification_code = "";
    },
    refundSubmit() {
      let data = {
        app_id: this.app_id,
        ordersn: this.refund.ordersn,
        refund_desc: this.refund.desc,
        verification_code: this.refund.verification_code,
      };
      this.$confirm("确定要为此订单退款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: "退款中,请耐心等待...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (this.allOrder == 2) {
            normalOrder_refund(data).then((res) => {
              if (res.code == 200) {
                loading.close();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.refund.desc = "";
                this.refund.ordersn = "";
                this.refund.money = "";
                this.refund.verification_code = "";
                this.refund.name = "";
                this.refundIsShow = false;
                this.getData(1);
              } else if (res.code == 202) {
                setInterval(() => {
                  this.times = this.normalOrderStatus(); //你的方法
                  loading.close();
                }, 10000);
              } else {
                loading.close();
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          } else {
            offline_orderRefund(data).then((res) => {
              if (res.code == 200) {
                loading.close();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.refund.desc = "";
                this.refund.ordersn = "";
                this.refund.verification_code = "";
                this.refund.money = "";
                this.refund.name = "";
                this.refundIsShow = false;
                this.getData(1);
              } else if (res.code == 202) {
                this.times = setInterval(() => {
                  this.refundStatus(); //你的方法
                  loading.close();
                }, 10000);
              } else {
                loading.close();
                this.$message({
                  type: "error",
                  message: res.msg,
                });
                // this.desc = "";
                // this.ordersn = "";
                // this.money = "";
                // this.refundIsShow = false;
              }
            });
          }
        })
        .catch(() => {});
    },
    async refundStatus() {
      try {
        let data = {
          app_id: this.app_id,
          ordersn: this.refund.ordersn,
        };
        const res = await offline_order_status(data);
        if (res.code == 200) {
          switch (res.data.refund_status) {
            case 0:
              this.$message.info("未退款");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.name = "";
              this.refund.money = "";
              this.refund.verification_code = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            case 1:
              this.$message.info("退款中,请耐心等待");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.name = "";
              this.refund.verification_code = "";
              this.refund.money = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            case 2:
              this.$message.success("退款完成");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.money = "";
              this.refund.verification_code = "";
              this.refund.name = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            default:
              this.$message.error("退款失败");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.verification_code = "";
              this.refund.name = "";
              this.refund.money = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async normalOrderStatus() {
      try {
        let data = {
          app_id: this.app_id,
          ordersn: this.refund.ordersn,
          verification_code: "",
        };
        const res = await normalOrder_refundStatus(data);
        if (res.code == 200) {
          switch (res.data.refund_status) {
            case 0:
              this.$message.info("未退款");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.name = "";
              this.refund.money = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            case 1:
              this.$message.info("退款中,请耐心等待");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.name = "";
              this.refund.money = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            case 2:
              this.$message.success("退款完成");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.money = "";
              this.refund.name = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
            default:
              this.$message.error("退款失败");
              clearInterval(this.times);
              this.times = null;
              this.refund.desc = "";
              this.refund.ordersn = "";
              this.refund.name = "";
              this.refund.money = "";
              this.refundIsShow = false;
              this.getData(1);
              break;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 15px;
    // display: flex;
    // flex-direction: column;
    .options {
      .options_item {
        width: 25%;
        display: inline-block;
      }
      // .options_input{
      //   width: 230px;
      // }
      .input_box_small {
        width: 240px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 115px;
        margin-right: 8px;
      }
      .inline_title {
        margin-left: 24px;
        margin-right: 12px;
      }
      .emp_search {
        margin-left: 15px;
      }
    }
    .table_box {
      // flex: 1;
      margin-top: 10px;
    }
    .page {
      margin-top: 15px;
    }
  }
  .dialog_option {
    margin-bottom: 15px;
    .options_item {
      display: inline-block;
      margin-left: 18px;
      .item_label {
        margin-right: 10px;
      }
      .select_box {
        width: 140px;
      }
    }
    .button_line {
      margin-top: 15px;
      padding-left: 18px;
    }
  }
  .align_c {
    text-align: center;
  }
  .stat_box {
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    .stat_item:first-child {
      margin: 0;
    }
    .stat_item {
      width: 9%;
      background: #fff;
      height: 100px;
    }
    .stat_item2 {
      width: 45.5%;
      background: #fff;
      height: 100px;
    }
    .stat_item3 {
      width: 45%;
      background: #fff;
      height: 100px;
    }
    .stat_item_title {
      height: 29px;
      line-height: 29px;
      padding-left: 10px;
      border-bottom: 1px solid #f5f5f5;
    }
    .stat_item_value {
      padding: 0px 10px;
      padding-top: 8px;
      font-size: 21px;
      line-height: 21px;
      color: #666;
      display: flex;
      span {
        font-size: 14px;
      }
    }
    .stat_item_value2 {
      text-align: center;
      line-height: 24px;
      color: #666;
      display: flex;
      .item_value_part {
        flex: 5;
        padding-top: 6px;
        .part_name {
          height: 30px;
          line-height: 30px;
        }
        .part_value {
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value3 {
      color: #666;
      display: flex;
      .item_value_part {
        padding-left: 10px;
        flex: 1;
        padding-top: 7px;
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value4 {
      color: #666;
      display: flex;
      text-align: center;
      .item_value_part {
        flex: 1;
        padding-top: 12px;
        .part_title4 {
          font-size: 13px;
          margin-bottom: 5px;
        }
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
  }
  .operation-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 0;
    align-items: start;
  }
  .operation-btn {
    text-align: center;
    min-width: 0;
  }
  .action-button {
    padding: 0;
    width: 100%;
    white-space: nowrap;
    color: #409eff;
  }
  .action-button-primary {
    color: #409eff;
  }
  .action-button-success {
    color: #67c23a;
  }
  .action-button-warning {
    color: #e6a23c;
  }
  .action-button-info {
    color: #909399;
  }
  .action-button-danger {
    color: #f56c6c;
  }
  .invoice-preview {
    padding: 4px 2px 0;
  }
  .invoice-preview-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f5f8ff 0%, #eef7ff 100%);
    border: 1px solid #e1ebff;
    margin-bottom: 16px;
  }
  .invoice-preview-title {
    min-width: 0;
  }
  .invoice-preview-name {
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
    color: #1f2d3d;
    word-break: break-all;
  }
  .invoice-preview-meta {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7a90;
  }
  .invoice-preview-dot {
    margin: 0 8px;
    color: #b4bfd1;
  }
  .invoice-preview-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .invoice-preview-item {
    padding: 14px 16px;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px solid #edf2f7;
    min-width: 0;
  }
  .invoice-preview-item-wide {
    grid-column: 1 / -1;
  }
  .invoice-preview-label {
    font-size: 12px;
    line-height: 18px;
    color: #8a97ab;
    margin-bottom: 6px;
  }
  .invoice-preview-value {
    font-size: 15px;
    line-height: 22px;
    color: #253041;
    word-break: break-all;
  }
  .invoice-preview-remark {
    white-space: pre-wrap;
  }
  .invoice-preview-actions {
    margin-top: 20px;
    text-align: right;
  }
}
.date_picker_delete {
  width: 140px;
}
::v-deep .el-popover,
.el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}
</style>
